import React from 'react';
import _ from 'lodash';
import { Link, withPrefix } from 'gatsby';
import slugify from 'slugify';
import PropTypes from 'prop-types';

import { CustomizableButton } from '~components/common/Button';
import { HTMLContent } from '../../Content';
import { stateEnums } from '../../../utils/enums';

import { listLayoutProps, listFrontmatterProps } from '../propTypes';

function AppendText({ frontmatter, stateName }) {
  if (!frontmatter.stateListAppendText) {
    return null;
  }

  const stateSlug = slugify(stateName.toLowerCase());
  const stateCode = stateEnums.find(
    (e) => e.option.toLowerCase() === stateName.toLowerCase()
  ).value;

  const linkTarget = withPrefix(
    _.template(frontmatter.stateListAppendLink)({
      stateCode,
      stateSlug,
      stateName,
    })
  );

  const linkText = _.template(frontmatter.stateListAppendText)({
    stateCode,
    stateSlug,
    stateName,
  });

  if (frontmatter.stateListAppendLinkIsButton) {
    return (
      <CustomizableButton
        to={linkTarget}
        title={linkText}
        isSecondary
        elementType='Link'
      >
        {linkText}
      </CustomizableButton>
    );
  }

  return (
    <Link to={linkTarget} title={linkText}>
      {linkText}
    </Link>
  );
}

AppendText.propTypes = {
  ...listFrontmatterProps,
  stateName: PropTypes.string.isRequired,
};

export default function defaultRenderer({
  state,
  frontmatter,
  infoSlug,
  infoFields,
}) {
  const stateName = state.fieldValue;

  return (
    <>
      {infoSlug.map((slug) => {
        const field = infoFields.find((f) => f.slug === slug);
        const info = state.nodes.find((f) => f.field_type === slug);
        if (!field || !info) {
          return '';
        }

        if (field.field_format === 'Boolean') {
          return '';
        }

        return (
          <div key={field.slug}>
            <HTMLContent content={info.html} />
            <AppendText frontmatter={frontmatter} stateName={stateName} />
          </div>
        );
      })}
    </>
  );
}

defaultRenderer.propTypes = listLayoutProps;
